const BUY_SELECTOR = '[data-pr-buy]';

function getCartAddUrl() {
  if (window.Theme?.routes?.cart_add_url) return window.Theme.routes.cart_add_url;
  const root = window.Shopify?.routes?.root || '/';
  return `${root}cart/add.js`;
}

function getCartUrl() {
  const root = window.Shopify?.routes?.root || '/';
  return `${root}cart.js`;
}

function getCartUpdateUrl() {
  const root = window.Shopify?.routes?.root || '/';
  return `${root}cart/update.js`;
}

function getCheckoutUrl() {
  const root = window.Shopify?.routes?.root || '/';
  return `${root}checkout`;
}

async function fetchJson(url, options = {}) {
  const response = await fetch(url, {
    credentials: 'same-origin',
    ...options,
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      ...options.headers,
    },
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok || result.status) {
    throw new Error(result.description || result.message || 'Impossible de mettre à jour le panier.');
  }
  return result;
}

function getVariantLines(cart, variantId) {
  return (cart.items || []).filter((item) => String(item.variant_id) === String(variantId));
}

async function normalizeExistingVariant(lines) {
  const updates = {};
  lines.forEach((line, index) => {
    const expectedQuantity = index === 0 ? 1 : 0;
    if (line.quantity !== expectedQuantity) updates[line.key] = expectedQuantity;
  });

  if (Object.keys(updates).length === 0) return;
  await fetchJson(getCartUpdateUrl(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates }),
  });
}

async function ensureVariantQuantityOne(variantId) {
  const cart = await fetchJson(getCartUrl());
  const existingLines = getVariantLines(cart, variantId);

  if (existingLines.length === 0) {
    await fetchJson(getCartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    });
  } else {
    await normalizeExistingVariant(existingLines);
  }

  const verifiedCart = await fetchJson(getCartUrl());
  const verifiedQuantity = getVariantLines(verifiedCart, variantId).reduce((total, item) => total + item.quantity, 0);
  if (verifiedQuantity !== 1) {
    throw new Error('La quantité du guide n’a pas pu être fixée à 1. Réessaie dans quelques instants.');
  }
}

function showError(container, message) {
  const error = container.querySelector('[data-pr-buy-error]');
  if (error) {
    error.textContent = message;
    error.hidden = false;
  } else {
    window.alert(message);
  }
}

function clearError(container) {
  const error = container.querySelector('[data-pr-buy-error]');
  if (!error) return;
  error.textContent = '';
  error.hidden = true;
}

function setLoading(buttons, activeButton, isLoading) {
  for (const button of buttons) {
    if (isLoading) {
      button.setAttribute('aria-disabled', 'true');
      if ('disabled' in button) button.disabled = true;
    } else {
      button.removeAttribute('aria-disabled');
      if ('disabled' in button) button.disabled = false;
    }
  }

  if (!activeButton) return;
  if (isLoading) {
    activeButton.dataset.prOriginalText = activeButton.textContent;
    activeButton.textContent = 'Chargement…';
    activeButton.setAttribute('aria-busy', 'true');
  } else {
    if (activeButton.dataset.prOriginalText) activeButton.textContent = activeButton.dataset.prOriginalText;
    delete activeButton.dataset.prOriginalText;
    activeButton.removeAttribute('aria-busy');
  }
}

function initPremierRevenuCheckout(container) {
  if (container.dataset.prCheckoutReady === 'true') return;
  container.dataset.prCheckoutReady = 'true';

  const buttons = Array.from(container.querySelectorAll(BUY_SELECTOR));
  let purchaseInProgress = false;

  for (const button of buttons) {
    button.addEventListener('click', async (event) => {
      event.preventDefault();
      if (purchaseInProgress) return;

      clearError(container);
      const variantId = button.dataset.variantId;
      if (!variantId || !/^\d+$/.test(variantId)) {
        showError(container, 'Le produit est indisponible. Vérifie le produit sélectionné dans l’éditeur Shopify.');
        return;
      }

      purchaseInProgress = true;
      setLoading(buttons, button, true);

      try {
        await ensureVariantQuantityOne(variantId);
        window.location.assign(getCheckoutUrl());
      } catch (error) {
        purchaseInProgress = false;
        setLoading(buttons, button, false);
        showError(container, error?.message || 'Une erreur est survenue. Réessaie dans quelques instants.');
      }
    });
  }
}

document.querySelectorAll('.pr-landing').forEach(initPremierRevenuCheckout);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll?.('.pr-landing').forEach(initPremierRevenuCheckout);
});
